export enum LanguageEnum {
    pl,
    en,
    de,
}
